import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";
import type { JSX } from "react";

import { SectionCardHeader } from "../../shared.js";
import type { Economics } from "../../types.js";
import { BudgetBar, formatUsd } from "../studioShared.js";

/** Spending card — today's estimated AI spend, token totals, and per-caller breakdown. */
export function SpendCard({ econ }: { econ: Economics | undefined }): JSX.Element {
  return (
    <Card data-testid="status-spend">
      <SectionCardHeader
        title="Spending today"
        subtitle="Estimated AI spend this budget day. Autonomous drafting sleeps at the cap; manual create always works."
      />
      <CardContent sx={{ px: 2.5, py: 2, display: "grid", gap: 1 }}>
        {!econ ? (
          <Skeleton variant="rounded" height={56} />
        ) : (
          <>
            <BudgetBar budget={econ.budget} />
            <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
              {econ.calls} call{econ.calls === 1 ? "" : "s"} ·{" "}
              {econ.input_tokens.toLocaleString()} in /{" "}
              {econ.output_tokens.toLocaleString()} out tokens
              {econ.estimated ? " · estimated" : ""}
            </Typography>
            {Object.keys(econ.by_caller).length > 0 && (
              <Box sx={{ display: "grid", gap: 0.25, mt: 0.5 }}>
                {Object.entries(econ.by_caller).map(([caller, cost]) => (
                  <Box
                    key={caller}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: 12,
                    }}
                  >
                    <Box component="span" sx={{ color: "text.secondary" }}>
                      {caller}
                    </Box>
                    <Box
                      component="span"
                      sx={{ fontFamily: "ui-monospace, monospace" }}
                    >
                      {formatUsd(cost)}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
